import { render, staticRenderFns } from "./Liquidation.vue?vue&type=template&id=2b009d4c&scoped=true&"
import script from "./Liquidation.vue?vue&type=script&lang=js&"
export * from "./Liquidation.vue?vue&type=script&lang=js&"
import style0 from "./Liquidation.vue?vue&type=style&index=0&id=2b009d4c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b009d4c",
  null
  
)

export default component.exports